/**
 * tourSteps/taskDrawerSteps.js
 * Comprehensive tour steps for the Task Details Drawer & Milestone management.
 */

export const taskDrawerSteps = [
    {
        title: 'Work Item Type: Task vs Milestone',
        description: 'Switch between standard operational Tasks (time-tracked units of work) and high-level Project Milestones (parent phases containing deliverables and child tasks).',
        selector: '[data-tour="task-item-type-switch"]',
        fallbackSelector: '[data-tour="task-header-status"]',
        placement: 'bottomLeft',
    },
    {
        title: 'Execution Status & Milestone Completion',
        description: 'Update the live execution stage. Marking a Milestone as "Completed" automatically launches the Deliverables Verification Modal to confirm criteria and push status directly to the CRE Client Portal.',
        selector: '[data-tour="task-header-status"]',
        placement: 'bottomLeft',
    },
    {
        title: 'Live Task Time Tracker',
        description: 'Start or stop tracking work with a single click. Logged time automatically syncs with employee attendance records and notifies if estimated hours are exceeded. (For Milestones, effort is aggregated automatically from nested child tasks).',
        selector: '[data-tour="task-timer-widget"]',
        fallbackSelector: '[data-tour="task-header-status"]',
        placement: 'bottom',
    },
    {
        title: 'Secure Share & Client Links',
        description: 'Generate private team links or external client preview links with customizable view permissions and expiry dates.',
        selector: '[data-tour="task-share-btn"]',
        placement: 'bottomRight',
    },
    {
        title: 'AI Task Overview & Executive Synthesis',
        description: 'AI continuously synthesizes task descriptions, checklist progress, and recent discussions. Click "View Full Summary" to open the deep-dive modal featuring sentiment analysis, blockers, and recommendations.',
        selector: '[data-tour="ai-task-overview"]',
        placement: 'bottom',
    },
    {
        title: 'Milestone Progress Card',
        description: 'When viewing a Milestone, this card visualizes progress across all nested Child Tasks with real-time percentage completion and delivery status.',
        selector: '[data-tour="milestone-progress-card"]',
        fallbackSelector: '[data-tour="task-metadata-grid"]',
        placement: 'bottom',
    },
    {
        title: 'Task Metadata & Milestone Criteria',
        description: 'Assign owners, select priority, set target due dates, and specify formal PM Completion Criteria with quick-suggestion templates.',
        selector: '[data-tour="task-metadata-grid"]',
        placement: 'bottom',
    },
    {
        title: 'Expected Deliverables Checklist',
        description: 'Define mandatory deliverables that must be verified before milestone completion. Track delivery status and review client or BD feedback.',
        selector: '[data-tour="milestone-deliverables-checklist"]',
        fallbackSelector: '[data-tour="task-metadata-grid"]',
        placement: 'top',
    },
    {
        title: 'Subtasks & Nested Child Tasks',
        description: 'Break tasks into actionable checklist items. For Milestones, add full Child Tasks that inherit milestone objectives and stack seamlessly in the drawer.',
        selector: '[data-tour="task-subtasks-section"]',
        placement: 'top',
    },
    {
        title: 'Collaboration Tabs, Files & AI Upload',
        description: 'Post updates with @mentions and direct @File links. When attaching documents, the AI Pre-Upload & Organization system classifies files into standard project folders.',
        selector: '[data-tour="task-tabs-section"]',
        fallbackSelector: '[data-tour="task-tabs-nav"]',
        placement: 'top',
    },
    {
        title: 'Immutable Activity Log & Audit Trail',
        description: 'Every status transition, assignee change, milestone update, and discussion note is permanently recorded for project governance.',
        selector: '[data-tour="task-activity-log"]',
        placement: 'top',
    },
];
